import PropTypes from "prop-types"
import { connect } from "react-redux"

import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"

import Affirm from "./affirm"
import Klarna from "./klarna"

const InternalFinancing = ({ cartTotal, price, wizardLoading }) => {
  if (price <= 0 || wizardLoading) {
    return ""
  }

  return (
    <>
      {/* US only */}
      {sl.config.enable_affirm && <Affirm price={price} />}
      {/* Non-US */}
      {sl.config.klarna_osm_pdp &&
        enableKlarnaCheckout() &&
        cartTotal <= sl.config.klarna_max && <Klarna price={price} />}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    cartTotal: state.cart.summary ? state.cart.summary.cart_total : 0,
    wizardLoading: state.wizard.loading,
  }
}

InternalFinancing.propTypes = {
  cartTotal: PropTypes.number,
  price: PropTypes.number,
  wizardLoading: PropTypes.string,
}

const Financing = connect(mapStateToProps)(InternalFinancing)

export default Financing
